// Mock data for Crash Check website

export const contactData = {
  phone: '+49 177 6468858',
  email: 'info@crash-check24.de',
  whatsapp: '+491776468858',
  instagram: 'https://www.instagram.com/crash_check24/',
  owner: 'Burak Kaya',
  company: 'Crash Check'
};

export const services = [
  {
    id: 1,
    title: 'Unfallgutachten',
    description: 'Professionelle Dokumentation nach Unfällen mit detaillierter Schadensanalyse für Versicherung und Anwalt.',
    icon: 'car-crash'
  },
  {
    id: 2,
    title: 'Schadengutachten',
    description: 'Objektive Bewertung von Fahrzeugschäden mit präziser Kostenermittlung.',
    icon: 'clipboard-check'
  },
  {
    id: 3,
    title: 'Fahrzeugbewertung',
    description: 'Marktgerechte Wertermittlung Ihres Fahrzeugs für Kauf, Verkauf oder Versicherung.',
    icon: 'badge-check'
  },
  {
    id: 4,
    title: 'Wertminderung',
    description: 'Ermittlung der merkantilen Wertminderung nach Unfallschäden.',
    icon: 'trending-down'
  },
  {
    id: 5,
    title: 'Nutzungsausfall',
    description: 'Berechnung des Nutzungsausfalls während der Reparaturzeit.',
    icon: 'calendar-x'
  },
  {
    id: 6,
    title: 'Beweissicherung',
    description: 'Schnelle Sicherung aller unfallrelevanten Beweise und Spuren.',
    icon: 'camera'
  }
];

export const trustPoints = [
  {
    id: 1,
    title: 'Unabhängig & objektiv',
    description: 'Neutrale Begutachtung ohne Interessenkonflikte',
    icon: 'shield-check'
  },
  {
    id: 2,
    title: 'Professionelle Dokumentation',
    description: 'Rechtssichere Aufbereitung für Versicherung und Gericht',
    icon: 'file-check'
  },
  {
    id: 3,
    title: 'Schnelle Kommunikation',
    description: '24/7 erreichbar via WhatsApp, Telefon oder E-Mail',
    icon: 'zap'
  }
];

export const processSteps = [
  {
    id: 1,
    title: 'Anfrage senden',
    description: 'Kontaktieren Sie uns per Telefon, WhatsApp oder Formular'
  },
  {
    id: 2,
    title: 'Vor-Ort Begutachtung',
    description: 'Schneller Termin an Ihrem Wunschort'
  },
  {
    id: 3,
    title: 'Gutachten erstellen',
    description: 'Präzise Dokumentation und rechtssichere Aufbereitung'
  },
  {
    id: 4,
    title: 'Nutzung für Versicherung',
    description: 'Rechtssicheres Gutachten direkt verwendbar'
  }
];

export const values = [
  {
    id: 1,
    title: 'Präzision',
    description: 'Detaillierte und exakte Schadensdokumentation',
    icon: 'target'
  },
  {
    id: 2,
    title: 'Geschwindigkeit',
    description: 'Schnelle Termine und kurze Bearbeitungszeiten',
    icon: 'zap'
  },
  {
    id: 3,
    title: 'Transparenz',
    description: 'Klare Kommunikation und nachvollziehbare Bewertungen',
    icon: 'eye'
  },
  {
    id: 4,
    title: 'Vertrauen',
    description: 'Unabhängige und objektive Begutachtung',
    icon: 'shield'
  }
];

export const infoPoints = [
  {
    id: 1,
    title: 'Wertminderung',
    description: 'Nach einem Unfall verliert Ihr Fahrzeug an Wert. Wir ermitteln die merkantile Wertminderung präzise.'
  },
  {
    id: 2,
    title: 'Nutzungsausfall',
    description: 'Während der Reparatur können Sie Ihr Fahrzeug nicht nutzen. Wir berechnen Ihren Anspruch.'
  },
  {
    id: 3,
    title: 'Reparaturkosten',
    description: 'Detaillierte Kalkulation aller anfallenden Reparaturkosten für die Schadensregulierung.'
  },
  {
    id: 4,
    title: 'Beweissicherung',
    description: 'Schnelle Dokumentation aller Spuren und Schäden direkt nach dem Unfall.'
  }
];

export const formSubmitMock = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Form submitted (MOCK):', formData);
      resolve({ success: true, message: 'Anfrage erfolgreich versendet!' });
    }, 1500);
  });
};